import { registerSW } from "virtual:pwa-register";

/**
 * Registers the service worker and prompts when a new app version is available.
 */
export function registerPwa(): void {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      if (import.meta.env.DEV) {
        void updateSW(true);
        return;
      }
      const shouldReload = window.confirm(
        "A new version of PTS is available. Reload now to update?"
      );
      if (shouldReload) {
        void updateSW(true);
      }
    },
    onOfflineReady() {
      console.info("[PWA] App is ready for offline use.");
    },
    onRegistered(registration) {
      if (registration) {
        console.info("[PWA] Service worker registered.");
      }
    },
    onRegisterError(error) {
      console.error("[PWA] Service worker registration failed:", error);
    },
  });
}
